// extracted by mini-css-extract-plugin
module.exports = {"layoutGrid":"_27tAlCaxe7RjNJp-KJyY02","titleDiv":"_1dOJcnVCgFZu8Ctx0h7Gba","objectListContainer":"_1BsZhHIKppqWKqmBKwZKY9"};